module.exports = __webpack_public_path__ + "img/face1.42d41e61.jpg";